import { ActionsColumn } from '@otp/ui';
import { LoginRuleListItem } from '../../types';
import { Edit, Remove } from '@otp/icons';
import {
  DeleteLoginRuleDocument,
  LoginRulesDocument,
} from 'src/graphql/generated/graphql';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { DeleteConfirmation } from 'src/components/common/form/delete-confirmation';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';

type ActionsFieldProps = {
  loginRule: LoginRuleListItem;
};

const QUERIES_TO_REFETCH = [LoginRulesDocument];

export const ActionsField = ({ loginRule }: ActionsFieldProps) => {
  const [deleteMutation] = useMutation(DeleteLoginRuleDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const navigate = useNavigate();

  const { t } = useTranslation(undefined, {
    keyPrefix: 'login-rules.list',
  });

  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = () => {
    deleteMutation({
      variables: {
        id: loginRule.id,
        reason: 'Deleted by user',
      },
    });

    setIsDeleting(false);
  };

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <Edit />,
            onClick: () =>
              navigate(`${Routes.loginRules.path}/${loginRule.id}`),
          },
          {
            icon: <Remove />,
            onClick: () => setIsDeleting(true),
          },
        ]}
      />
      <DeleteConfirmation
        objectTitle={loginRule.name}
        objectType={t('login-rules-list')}
        open={isDeleting}
        onClose={() => setIsDeleting(false)}
        onConfirm={onDelete}
      />
    </>
  );
};
